module.exports = __webpack_public_path__ + "img/设备2web.3f9b24fa.png";